function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { setContext, init as init$1 } from '@sentry/browser';
import { applySdkMetadata } from '@sentry/core';
import { version } from 'react';
/**
 * Inits the React SDK
 */ function init(options) {
    var opts = _object_spread({}, options);
    applySdkMetadata(opts, 'react');
    setContext('react', {
        version: version
    });
    return init$1(opts);
}
export { init }; //# sourceMappingURL=sdk.js.map
